export var Paths;

(function (Paths) {
  Paths["Url"] = ":url";
})(Paths || (Paths = {}));